import { Grid } from '@mui/material';
import { AppLayout } from 'layout';
import { UsersTable } from 'modules/Users/components';

type Props = {};

const UsersContainer = (props: Props) => {
  return (
    <AppLayout>
      <UsersTable />
    </AppLayout>
  );
};

export default UsersContainer;
